module["exports"] = [
  "02 ### ####",
  "03# ### ###",
  "04# ### ###",
  "+389 2 ### ####",
  "+389 3# ### ###",
  "+389 4# ### ###",
  "00389 2 ### ####",
  "00389 3# ### ###",
  "00389 4# ### ###"
];
